import {gringortenRaw} from "../gringorten";
import quincuncial from "./index";

export default function() {
  return quincuncial(gringortenRaw)
      .scale(176.423);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo-projection/src/quincuncial/gringorten.js
// module id = 302
// module chunks = 0